exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#box1[data-v-b89cb476]{position:relative;width:100%;height:500px;margin:0 auto}#box2[data-v-b89cb476],img[data-v-b89cb476]{position:relative;width:100%;height:100%}#wenzi[data-v-b89cb476],img[data-v-b89cb476]{clear:both}#wenzi[data-v-b89cb476]{position:relative;width:150px;top:-47%;left:50%;text-align:center;color:#fff;font-size:30px}p[data-v-b89cb476]{font-size:15px;text-align:justify}", ""]);

// exports
